import React from 'react';

import { useTranslation, Trans } from "react-i18next";

import Fade from 'react-reveal/Fade'

function WhyChoose () {

    const { t } = useTranslation();
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
            <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto relative">
                <div className="flex items-center justify-center">
                    <p className="text-[28px] xl:text-[45px] open-sans text-[#F26522] text-center leading-[1.4]">
                        <Trans>{t("CompositeReinforcement.26")}</Trans>
                    </p>
                </div>
                <div className='flex flex-col xl:flex-row justify-between gap-y-[20px] mt-[30px] xl:mt-[70px]'>
                    <div className='xl:w-[265px] flex flex-col gap-y-[20px]'>
                        <div className='flex gap-[9px]'>
                            <div className='w-[5px] h-[5px] rounded-full bg-[#F26522] flex-shrink-0 mt-[9px]'></div>
                            <p className='open-sans font-[300] text-[#F6F6F6] text-[14px] xl:text-[16px]'>{t('compositerein.add.15')}</p>
                        </div>
                        <div className='flex gap-[9px]'>
                            <div className='w-[5px] h-[5px] rounded-full bg-[#F26522] flex-shrink-0 mt-[9px]'></div>
                            <p className='open-sans font-[300] text-[#F6F6F6] text-[14px] xl:text-[16px]'>{t('compositerein.add.16')}</p>
                        </div>
                        <div className='flex gap-[9px]'>
                            <div className='w-[5px] h-[5px] rounded-full bg-[#F26522] flex-shrink-0 mt-[9px]'></div>
                            <p className='open-sans font-[300] text-[#F6F6F6] text-[14px] xl:text-[16px]'>{t('compositerein.add.17')}</p>
                        </div>
                        <div className='flex gap-[9px]'>
                            <div className='w-[5px] h-[5px] rounded-full bg-[#F26522] flex-shrink-0 mt-[9px]'></div>
                            <p className='open-sans font-[300] text-[#F6F6F6] text-[14px] xl:text-[16px]'>{t('compositerein.add.18')}</p>
                        </div>
                    </div>
                    <div className='xl:w-[265px] flex flex-col gap-y-[20px]'>
                        <div className='flex gap-[9px]'>
                            <div className='w-[5px] h-[5px] rounded-full bg-[#F26522] flex-shrink-0 mt-[9px]'></div>
                            <p className='open-sans font-[300] text-[#F6F6F6] text-[14px] xl:text-[16px]'>{t('compositerein.add.19')}</p>
                        </div>
                        <div className='flex gap-[9px]'>
                            <div className='w-[5px] h-[5px] rounded-full bg-[#F26522] flex-shrink-0 mt-[9px]'></div>
                            <p className='open-sans font-[300] text-[#F6F6F6] text-[14px] xl:text-[16px]'>{t('compositerein.add.20')}</p>
                        </div>
                        <div className='flex gap-[9px]'>
                            <div className='w-[5px] h-[5px] rounded-full bg-[#F26522] flex-shrink-0 mt-[9px]'></div>
                            <p className='open-sans font-[300] text-[#F6F6F6] text-[14px] xl:text-[16px]'>{t('compositerein.add.21')}</p>
                        </div>
                        <div className='flex gap-[9px]'>
                            <div className='w-[5px] h-[5px] rounded-full bg-[#F26522] flex-shrink-0 mt-[9px]'></div>
                            <p className='open-sans font-[300] text-[#F6F6F6] text-[14px] xl:text-[16px]'>{t('compositerein.add.22')}</p>
                        </div>
                    </div>
                    <div className='xl:w-[265px] flex flex-col gap-y-[20px]'>
                        <div className='flex gap-[9px]'>
                            <div className='w-[5px] h-[5px] rounded-full bg-[#F26522] flex-shrink-0 mt-[9px]'></div>
                            <p className='open-sans font-[300] text-[#F6F6F6] text-[14px] xl:text-[16px]'>{t('compositerein.add.23')}</p>
                        </div>
                        <div className='flex gap-[9px]'>
                            <div className='w-[5px] h-[5px] rounded-full bg-[#F26522] flex-shrink-0 mt-[9px]'></div>
                            <p className='open-sans font-[300] text-[#F6F6F6] text-[14px] xl:text-[16px]'>{t('compositerein.add.24')}</p>
                        </div>
                    </div>
                </div>               
            </div>
        </div>
    );
}

export default WhyChoose;